// components/Layout.jsx
import React from 'react';
import TopNavBar from './TopNavBar';
import Footer from './Footer';
import '../styles/AppLayout.scss';

function Layout({ children }) {
  return (
    <div className="app-container">
      <TopNavBar />
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
